module.exports = __webpack_public_path__ + "img/add_icon.4535b758.png";